"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSupportServerErrorMockData = exports.buildWebhookAutoDisabledMockData = exports.buildCustomDomainFailedMockData = exports.buildCustomDomainSucceededMockData = exports.buildQuickbooksDisconnectedNotificationMockData = exports.buildScheduledEmailConfirmationMockData = exports.buildNbctcNewLeadSignedUpMockData = exports.buildNewsletterSignupNotificationMockData = void 0;
const organization_facing_base_1 = require("./organization-facing-base");
const buildNewsletterSignupNotificationMockData = ({ locale = "en", subject = "Someone just signed up", firstName = "John", formName = "Monthly Newsletter", organizationPageUrl = "", welcomeSequenceUrl = "https://www.zeffy.com/o/crm/forms/edit?newsletterFormId=3f8c1d92-5b47-4e0a-9c31-7ad2be5106fb#automations", contactFirstName = "Jane", contactLastName = "Donor", contactEmail = "jane.donor@example.com", contactPhoneNumber = "+1 514 555 0142", contactAddress = "123 Main Street West", contactCity = "Montreal", contactState = "Quebec", contactCountry = "Canada", contactLanguage = "English", contactCommunicationPreferences = "General Communications; Monthly newsletter", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    formName,
    organizationPageUrl,
    welcomeSequenceUrl,
    contactFirstName,
    contactLastName,
    contactEmail,
    contactPhoneNumber,
    contactAddress,
    contactCity,
    contactState,
    contactCountry,
    contactLanguage,
    contactCommunicationPreferences,
});
exports.buildNewsletterSignupNotificationMockData = buildNewsletterSignupNotificationMockData;
const buildNbctcNewLeadSignedUpMockData = ({ locale = "en", subject = "New NBCTC lead signed up", referralCode = "NBCTC-2026", orgName = "Riverside Youth Soccer", orgState = "Vermont", orgId = "8b21f4a0-6c93-4d75-a1e8-52f0cb9d3471", contactFirstName = "Jane", contactLastName = "Donor", contactEmail = "jane.donor@example.com", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    referralCode,
    orgName,
    orgState,
    orgId,
    contactFirstName,
    contactLastName,
    contactEmail,
});
exports.buildNbctcNewLeadSignedUpMockData = buildNbctcNewLeadSignedUpMockData;
const buildScheduledEmailConfirmationMockData = ({ locale = "en", subject = "Your scheduled email has been sent", firstName = "John", numberRecipients = 1284, emailSentDateTime = "March 14, 2026 at 9:00 AM", emailLink = "https://www.zeffy.com/en-US/o/emails", sentEmailSubject = "Spring Gala 2026 — you're invited!", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    numberRecipients,
    emailSentDateTime,
    emailLink,
    sentEmailSubject,
});
exports.buildScheduledEmailConfirmationMockData = buildScheduledEmailConfirmationMockData;
const buildQuickbooksDisconnectedNotificationMockData = ({ locale = "en", subject = "QuickBooks has been disconnected", firstName = "John", organizationName = "Bright Futures Foundation", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    organizationName,
});
exports.buildQuickbooksDisconnectedNotificationMockData = buildQuickbooksDisconnectedNotificationMockData;
const buildCustomDomainSucceededMockData = ({ locale = "en", subject = "Your custom email domain is verified", firstName = "John", redirectionUrl = "https://www.zeffy.com/en-US/o/settings/emails", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    redirectionUrl,
});
exports.buildCustomDomainSucceededMockData = buildCustomDomainSucceededMockData;
const buildCustomDomainFailedMockData = ({ locale = "en", subject = "Your custom email domain could not be verified", firstName = "John", redirectionUrl = "https://www.zeffy.com/en-US/o/settings/emails", failureDetails = "CNAME em1234.your-organization.org → could not be resolved\nDKIM s1._domainkey.your-organization.org → record not found", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    redirectionUrl,
    failureDetailsHtml: (0, organization_facing_base_1.embedPlainTextForMock)(failureDetails),
});
exports.buildCustomDomainFailedMockData = buildCustomDomainFailedMockData;
const buildWebhookAutoDisabledMockData = ({ locale = "en", subject = "Your Zeffy webhook has been paused", firstName = "John", webhookUrl = "https://hooks.example.org/zeffy/payments", abandonedDeliveryCount = 3, settingsUrl = "https://www.zeffy.com/en-US/o/settings?openIntegrations=true", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    webhookUrl,
    abandonedDeliveryCount,
    settingsUrl,
});
exports.buildWebhookAutoDisabledMockData = buildWebhookAutoDisabledMockData;
const buildSupportServerErrorMockData = ({ locale = "en", subject = "Support needed", alertMessage = "Attempt to cancel subscription sub_1P9xKtL2mQvR7dYz failed. It must be handled by support", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    alertMessageHtml: (0, organization_facing_base_1.embedPlainTextForMock)(alertMessage),
});
exports.buildSupportServerErrorMockData = buildSupportServerErrorMockData;
